// extracted by mini-css-extract-plugin
export default {"lang-buttons":"Index_lang-buttons__gggS1","modal":"Index_modal__5SwCJ"};